import React, { FC, Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';

import { menuData } from '../MenuLeft';
import { RootState } from '../../redux/store';

import './style.scss';

type BreadcrumbTypes = {
  name?: string;
};

const AppBreadcrumb: FC<BreadcrumbTypes> = (props) => {
  const theme = useSelector<RootState>((state) =>
    state.app.layoutState.themeLight ? 'light' : 'dark'
  );
  const [breadcrumb, setBreadcrumb] = useState<any>([]);
  const location = useSelector<RootState>((state) => state.router.location);

  const getPath = (data: Array<any>, url: string, parents: Array<any> = []): any => {
    const items = data
      .reduce((result, entry) => {
        if (result.length) {
          return result;
        }
        if (entry.url === url) {
          return [entry].concat(parents);
        }
        if (entry.children) {
          const nested = getPath(entry.children, url, [entry].concat(parents));
          return nested || result;
        }
        if (entry.regex && entry.regex.test(url)) {
          return [entry].concat(parents || entry.title);
        }
        return result;
      }, [])
      .filter((i) => !!i);
    return items.length > 0 ? items : [];
  };

  const getBreadcrumb = (items: any) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const url = location.pathname || '';
    const [activeMenuItem, ...path] = getPath(items, url);
    if (activeMenuItem && path.length) {
      return path.reverse().map((item: any, index: number) => {
        if (index === path.length - 1) {
          return (
            <Fragment key={item.key}>
              <Breadcrumb.Item key={item.key}>{item.title}</Breadcrumb.Item>
              <Breadcrumb.Item key={`${item.key}${activeMenuItem.title}`}>
                <strong>{activeMenuItem.title}</strong>
              </Breadcrumb.Item>
            </Fragment>
          );
        }
        return <Breadcrumb.Item key={item.key}>{item.title}</Breadcrumb.Item>;
      });
    }
    if (activeMenuItem) {
      return (
        <Breadcrumb.Item key={activeMenuItem.key}>
          <strong>{activeMenuItem.title}</strong>
        </Breadcrumb.Item>
      );
    }
    return (
      <Breadcrumb.Item key={props.name}>
        <strong>{props.name || url}</strong>
      </Breadcrumb.Item>
    );
  };

  useEffect(() => {
    setBreadcrumb(getBreadcrumb(menuData));
  }, [location]);

  return (
    <div className="cvta-breadcrumb__content-wrapper">
      <Breadcrumb separator=">" className={`breadcrumb__content--${theme}`}>
        <Breadcrumb.Item key="home">
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        {breadcrumb}
      </Breadcrumb>
    </div>
  );
};

export default AppBreadcrumb;
